const cardItems = [
  {
    id: 1,
    title: '春日华尔兹',
    category: '韩剧 · 爱情',
    rating: '9.4',
    episodes: '16集全',
    desc: '两位顶尖舞者在艺术与爱情的十字路口相遇，从彼此较量到相知相守，演绎一场关于梦想与爱情的华尔兹。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20romantic%20Korean%20drama%20poster%20with%20couple%20dancing%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20cream%20tones%2C%20dreamy%20spring%20atmosphere%2C%20ballet%20and%20dance%20theme%2C%20cinematic%20portrait%20style%2C%20Korean%20television%20drama%20aesthetic&width=600&height=800&seq=cards-drama-01&orientation=portrait',
  },
  {
    id: 2,
    title: '暗影追踪 第三季',
    category: '日剧 · 悬疑',
    rating: '9.2',
    episodes: '更新至8集',
    desc: '天才侦探与连环杀手的终极对决，每一个线索都指向更深层的阴谋。本季故事迎来最震撼的反转结局。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20Japanese%20detective%20drama%20poster%20with%20detective%20silhouette%20in%20rainy%20Tokyo%20street%2C%20neon%20reflections%2C%20noir%20cinematography%20style%2C%20suspenseful%20moody%20atmosphere%2C%20crime%20thriller%20aesthetic&width=600&height=800&seq=cards-drama-02&orientation=portrait',
  },
  {
    id: 3,
    title: '江户物语 特别篇',
    category: '日剧 · 古装',
    rating: '9.0',
    episodes: '1集特别篇',
    desc: '回到江户时代的京都，一段跨越身份与世俗的唯美故事。特别篇以更宏大的制作和更细腻的情感打动观众。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20period%20drama%20poster%20with%20traditional%20kimono%20and%20ancient%20Kyoto%20street%2C%20autumn%20maple%20leaves%2C%20warm%20lantern%20light%2C%20historical%20aesthetic%2C%20soft%20golden%20and%20crimson%20tones%2C%20cinematic%20portrait&width=600&height=800&seq=cards-drama-03&orientation=portrait',
  },
  {
    id: 4,
    title: '首尔恋爱指南',
    category: '韩剧 · 喜剧',
    rating: '8.9',
    episodes: '更新至12集',
    desc: '都市男女在首尔的浪漫喜剧，每集一个恋爱小技巧，笑中带泪的真实恋爱图鉴。轻松愉快又治愈。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Bright%20cheerful%20Korean%20romantic%20comedy%20drama%20poster%20with%20modern%20Seoul%20couple%20in%20colorful%20cafe%2C%20pastel%20color%20palette%2C%20youthful%20vibrant%20energy%2C%20K-drama%20poster%20style%2C%20clean%20modern%20production&width=600&height=800&seq=cards-drama-04&orientation=portrait',
  },
  {
    id: 5,
    title: '急诊室的故事',
    category: '韩剧 · 医疗',
    rating: '9.1',
    episodes: '20集全',
    desc: '顶尖医院急诊室里的人生百态，医生们在生死边缘与时间赛跑，感人至深的医疗人文大剧。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Intense%20medical%20drama%20poster%20with%20doctors%20in%20hospital%20emergency%20room%2C%20dramatic%20lighting%2C%20Korean%20medical%20drama%20aesthetic%2C%20professional%20atmosphere%2C%20warm%20and%20cool%20tone%20contrast%2C%20emotional%20humanistic%20storytelling%20visual&width=600&height=800&seq=cards-drama-05&orientation=portrait',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            热门剧集
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            当下最受关注的日韩热门电视剧，立即开启你的追剧之旅
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {cardItems.map((item) => (
            <article
              key={item.id}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-300/50 transition-all duration-200 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-1 rounded bg-black/60 text-white text-xs font-medium whitespace-nowrap">
                    {item.rating}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                  <span className="text-white text-xs font-medium">立即观看</span>
                </div>
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <span className="text-xs text-primary-600 font-medium whitespace-nowrap">{item.category}</span>
                <h3 className="mt-1 text-sm font-bold font-heading text-foreground-950 line-clamp-1">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-600 leading-relaxed line-clamp-2 flex-1">
                  {item.desc}
                </p>
                <div className="mt-2 text-xs text-foreground-500">
                  <i className="ri-film-line mr-1"></i>
                  {item.episodes}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}